import styled from 'styled-components'
import theme from '@app/ui/theme'

export const TeeWrapper = styled.div`
  /* Wide enough for the tee row, and no taller than what is in it. */
  width: 560px;
  padding-bottom: 26px;
  background-color: white;
  border-radius: 12px;
`
export const TeeHeader = styled.div`
  height: 65px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
export const CloseButton = styled.div`
  cursor: pointer;
  background-color: #a5a5a5;
  width: 36px;
  height: 36px;
  border-radius: ${theme.borderRadius}px;
  margin-left: 20px;
  justify-content: center;
  align-items: center;
  display: flex;
  color: white;
  margin-right: 10px;
  float: right;
`
export const TeeTitle = styled.div`
  flex: 1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: #282828;
  text-align: center;
  /* Balances the close button on the other side, so the title sits in the
     middle of the header rather than off to one side of it. */
  margin-left: 46px;
`
export const TeeLine = styled.div`
  border-bottom: 1px solid #cecece;
`
export const TeeContent = styled.div`
  margin: 30px 26px 0px 26px;
`
// The buttons sit at the right end of the modal, the way the footer of the
// tee set modal does.
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 25px;
`
